import { rem } from "@mantine/core"; // Ou votre fonction rem personnalisée

export function IconLinkedinWithTip({
  size = 24,
  style,
  fill,
  tipIcon,
  tipStyles,
  ...others
}) {
  const iconSize = rem(size);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        width: iconSize,
        height: iconSize,
        ...style,
      }}
    >
      {/* Icône LinkedIn Classique */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        style={{ width: "100%", height: "100%" }}
        {...others}
      >
        {/* Le carré bleu arrondi */}
        <path
          fill={fill}
          d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5z"
        />
        {/* Le "in" en blanc */}
        <path
          fill="#fff"
          d="M8 19h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 11.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-10h3v1.385c1.396-2.586 7-2.777 7 2.476v6.139z"
        />
      </svg>

      {/* Le tipIcon (L'oeil) positionné en haut à droite */}
      {tipIcon && (
        <div
          style={{
            position: "absolute",
            top: rem(-4), // Ajustez pour faire dépasser légèrement
            right: rem(-4),
            lineHeight: 0,
            padding: rem(1.5), // Petit espace autour
            background: "white", // Fond blanc pour faire ressortir l'icône
            borderRadius: "4px",
            boxShadow: "0 0 4px rgba(0,0,0,0.2)", // Optionnel: pour donner du relief
            ...tipStyles
          }}
        >
          {tipIcon}
        </div>
      )}
    </div>
  );
}
